import React from 'react';
import { Card, CardContent } from '../../../components/ui/card';
import { Badge } from '../../../components/ui/badge';
import { CheckCircle2, AlertTriangle, Target } from 'lucide-react';

const FIT_COLORS = {
  good_fit: 'bg-green-500/20 text-green-400 border-green-500/30',
  maybe: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
  not_fit: 'bg-red-500/20 text-red-400 border-red-500/30',
};

function SummaryCard({ synthesis }) {
  if (!synthesis || !synthesis.generated_at) {
    return <p className="text-white/40 text-sm">No synthesis available.</p>;
  }
  const fitClass = FIT_COLORS[synthesis.fit_label] || 'bg-white/10 text-white/60 border-white/20';

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <Badge className={`${fitClass} border`}>{synthesis.fit_label || 'n/a'}</Badge>
        <span className="text-sm text-white/60 font-mono">{synthesis.fit_score ?? '—'}/100</span>
        <span className="text-xs text-white/40">{synthesis.fit_score_rationale}</span>
      </div>

      <Card className="bg-white/5 border-white/10">
        <CardContent className="p-4">
          <h4 className="text-xs font-semibold tracking-wider text-white/40 uppercase mb-2">Summary</h4>
          <p className="text-sm text-white/80 whitespace-pre-line leading-relaxed">{synthesis.summary}</p>
        </CardContent>
      </Card>

      <div className="grid grid-cols-2 gap-4">
        <Card className="bg-green-500/5 border-green-500/20">
          <CardContent className="p-4">
            <h4 className="text-xs font-semibold tracking-wider text-green-400 uppercase mb-2 flex items-center gap-1">
              <CheckCircle2 className="w-3.5 h-3.5" /> Strengths
            </h4>
            <ul className="space-y-1">
              {(synthesis.strengths || []).map((s, i) => (
                <li key={i} className="text-xs text-white/70">• {s}</li>
              ))}
            </ul>
          </CardContent>
        </Card>
        <Card className="bg-red-500/5 border-red-500/20">
          <CardContent className="p-4">
            <h4 className="text-xs font-semibold tracking-wider text-red-400 uppercase mb-2 flex items-center gap-1">
              <AlertTriangle className="w-3.5 h-3.5" /> Concerns
            </h4>
            <ul className="space-y-1">
              {(synthesis.concerns || []).map((c, i) => (
                <li key={i} className="text-xs text-white/70">• {c}</li>
              ))}
            </ul>
          </CardContent>
        </Card>
      </div>

      <Card className="bg-[#00d4aa]/5 border-[#00d4aa]/20">
        <CardContent className="p-4">
          <h4 className="text-xs font-semibold tracking-wider text-[#00d4aa] uppercase mb-2 flex items-center gap-1">
            <Target className="w-3.5 h-3.5" /> Next Action
          </h4>
          <p className="text-sm text-white/80">
            <span className="font-medium">{synthesis.recommended_next_action}</span>
            {synthesis.next_action_note ? ` — ${synthesis.next_action_note}` : ''}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}

export default SummaryCard;
